import { Button, Stack } from "@mui/material";

import { AddRoutePointETAButton } from "components/AddRoutePointETAButton";
import { LatestShipmentRoutePointETADisplay } from "components/LatestShipmentRoutePointETADisplay";
import { ShipmentStatusHistoryTable } from "components/ShipmentStatusHistoryTable";
import { useCarrierShipmentPageContext, useDisclosure } from "hooks";
import { carrierHasBookingWriteAccess } from "utils";

import { CancelShipmentBookingButton } from "./components/CancelShipmentBookingButton";
import { MarkShipmentAsDeliveredButton } from "./components/MarkShipmentAsDeliveredButton";
import { MarkShipmentAsPickedUpButton } from "./components/MarkShipmentAsPickedUpButton";
import { ShipmentStatusDisplay } from "./components/ShipmentStatusDisplay";

interface Props {
  dividerComponent: JSX.Element;
}

export function UpdateShipmentStateSection(props: Props) {
  const { dividerComponent } = props;
  const { shipment, onRefresh } = useCarrierShipmentPageContext();
  const {
    isOpen: historyOpen,
    onClose: onCloseHistory,
    onOpen: onOpenHistory,
  } = useDisclosure(false);

  // scenarios where no component is rendered.
  if (
    shipment?.info?.booked_at == null ||
    !carrierHasBookingWriteAccess(shipment) ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT"
  ) {
    return null;
  }

  return (
    <Stack direction="column" mb="1.5rem">
      {dividerComponent}
      <Stack direction="column" spacing={1}>
        <ShipmentStatusDisplay />
        <LatestShipmentRoutePointETADisplay shipment={shipment} />
      </Stack>
      <Stack sx={{ pt: "1rem", pb: "1rem" }} direction="row">
        <Stack width="50%" direction="row" justifyContent="left" spacing={1.5}>
          <AddRoutePointETAButton
            shipment={shipment}
            onETACreatedSuccess={onRefresh}
          />
          {shipment.shipment_status !== "PICKED_UP" && (
            <MarkShipmentAsPickedUpButton />
          )}
          <MarkShipmentAsDeliveredButton />
        </Stack>
        <Stack width="50%" direction="row" justifyContent="right" spacing={2}>
          <Button
            variant="text"
            onClick={historyOpen ? onCloseHistory : onOpenHistory}
          >
            {historyOpen ? "Hide history" : "Show history"}
          </Button>
          <CancelShipmentBookingButton />
        </Stack>
      </Stack>
      {historyOpen && <ShipmentStatusHistoryTable shipment={shipment} />}
    </Stack>
  );
}
